export const COMPANY_CREATED_SUCCESS = "Company created successfully.";
export const COMPANY_CREATED_FAILED = "Failed to create company.";

export const COMPANY_UPDATED_SUCCESS = "Company updated successfully.";
export const COMPANY_UPDATED_FAILED = "Failed to update company.";

export const USER_ROLE_UPDATE_SUCCESS = "User role updated successfully.";
export const USER_ROLE_UPDATE_FAIL = "Failed to update user role.";
export const USER_ROLE_UPDATE_NOT_ALLOWED = "you cannot remove admin role";

export const USER_CREATED_SUCCESS = "User created successfully. A link with temporary password has been sent.";
export const USER_CREATED_FAILED = "Failed to create user.";

export const USER_STATUS_UPDATE_SUCCESS = "User status updated successfully.";
export const USER_STATUS_UPDATE_FAILED = "Failed to update user status.";

export const CAMPAIGN_CREATED_SUCCESS = "Campaign created successfully.";
export const CAMPAIGN_CREATED_FAILED = "Failed to create a campaign.";

export const CAMPAIGN_UPDATE_SUCCESS = "Campaign updated successfully.";
export const CAMPAIGN_UPDATE_FAILED = "Failed to update the campaign.";

export const PROFILE_UPDATE_SUCCESS = "Profile details updated successfully.";
export const PROFILE_UPDATE_FAILED = "Failed to update the profile.";

export const INSIGHT_CREATED_SUCCESS = "Insight created successfully.";
export const INSIGHT_CREATED_FAILED = "Failed to create a insight.";

export const PHRASE_ADDED_SUCCESS = "Phrases updated successfully.";
export const PHRASE_ADDED_FAILED = "Failed to save the phrase.";

export const PHRASE_DELETED_SUCCESS = "Phrase deleted successfully.";
export const PHRASE_DELETED_FAILED = "Failed to delete the phrase.";

export const CONVERSATION_UPLOAD_SUCCESS = "Audio uploaded, conversation created successfully.";
export const CONVERSATION_UPLOAD_FAILED = "Failed to upload audio and create conversation.";

export const ARCHIVE_CONVERSATION_SUCCESS = "Conversation(s) archived successfully.";
export const ARCHIVE_CONVERSATION_FAILED = "Failed to archive the conversation(s).";

export const UNARCHIVE_CONVERSATION_SUCCESS = "Conversation(s) unarchive successfully.";
export const UNARCHIVE_CONVERSATION_FAILED = "Failed to unarchive the conversation(s).";

export const AGENT_NAME_UPDATE_SUCCESS = "Agent name updated successfully.";
export const AGENT_NAME_UPDATE_FAILED = "Failed to update the agent name.";

export const ONLY_ONE_FILE_ALLOWED = "You have selected too many files. Please upload only one file."; 

export const MARK_HIGH_RISK_SUCCESS = "Alert status updated successfully.";
export const MARK_HIGH_RISK_FAILED = "Failed to update the alert status.";

export const UPDATE_INSIGHT_SET_SUCCESS = "Insight alert set successfully.";
export const UPDATE_INSIGHT_UNSET_SUCCESS = "Insight alert unset successfully.";
export const UPDATE_INSIGHT_FAILED = "Failed to update the Insight.";

export const CAMPAIGN_PINNED_SUCCESS = "Campaign pinned successfully.";
export const CAMPAIGN_UNPINNED_SUCCESS = "Campaign unpinned successfully.";
export const CAMPAIGN_PINNED_FAILED = "Failed to update the campaign pin.";

export const MARK_ALERT_READ_SUCCESS = "Alert(s) marked as read successfully.";
export const MARK_ALERT_READ_FAILED = "Failed to read the alert(s).";

export const PASSWORD_UPDATE_SUCCESS = "Password updated successfully.";
export const PASSWORD_UPDATE_FAILED = "Failed to update password. The current password you entered may be incorrect.";